const bcs:any = {
  //auth
  context: {sv:'context',lb:'Context',nm:'cxi',nx:'cxx',vf:'rid',vx:'rix',df:'nam',rf:'ctx'},
  entity:{sv:'entity',lb:'Entity',nm:'eni',nx:'enx',vf:'rid',vx:'rix',df:'nam',rf:'enm'},
  entitytype:{sv:'entitytype',lb:'EntityType',nm:'eti',nx:'etx',vf:'rid',vx:'rix',df:'nam',rf:'ety'},
  language:{sv:'language',lb:'Language',nm:'lgi',nx:'lgx',vf:'rid',vx:'rix',df:'nam',rf:'lgn'},
  loginstatus:{sv:'loginstatus',lb:'Login Status',nm:'lsi',nx:'lsx',vf:'rid',vx:'rix',df:'nam',rf:'lsn'},
  loglevel:{sv:'loglevel',lb:'Log Level',nm:'lvi',nx:'lvx',vf:'rid',vx:'rix',df:'nam',rf:'lvn'},
  role:{sv:'role',lb:'Role',nm:'roi',nx:'rox',vf:'rid',vx:'rix',df:'nam',rf:'rnm'},
  user:{sv:'user',lb:'User',nm:'usi',nx:'usx',vf:'rid',vx:'rix',df:'nam',rf:'unm'},

  //core basics
  configuration:{sv:'configuration',lb:'Configuration',nm:'cfi',nx:'cfx',vf:'rid',vx:'rix',df:'nam',rf:'cfn'},
  contacttype:{sv:'contacttype',lb:'Type',nm:'cti',nx:'ctx',vf:'rid',vx:'rix',df:'nam',rf:'ctn'},
  country:{sv:'country',lb:'Country',nm:'coi',nx:'cox',vf:'rid',vx:'rix',df:'nam',rf:'coy'},
  currency:{sv:'currency',lb:'Currency',nm:'cui',nx:'cux',vf:'rid',vx:'rix',df:'nam',rf:'cur'},
  dashtype:{sv:'dashtype',lb:'Dashtype',nm:'dti',nx:'dtx',vf:'rid',vx:'rix',df:'nam',rf:'dtn'},
  devicetype:{sv:'devicetype',lb:'Device Type',nm:'dti',nx:'dtx',vf:'rid',vx:'rix',df:'nam',rf:'dtn'},
  district:{sv:'district',lb:'District',nm:'dsi',nx:'dsx',vf:'rid',vx:'rix',df:'nam',rf:'dsn'},
  enloc:{sv:'enloc',lb:'Location',nm:'lci',nx:'lcx',vf:'rid',vx:'rix',df:'nam',rf:'lcc'},
  enquirytype:{sv:'enquirytype',lb:'Type',nm:'eti',nx:'etx',vf:'rid',vx:'rix',df:'nam',rf:'etn'},
  enquirychannel:{sv:'enquirychannel',lb:'Channel',nm:'eci',nx:'ecx',vf:'rid',vx:'rix',df:'nam',rf:'ecn'},
  enquirystate:{sv:'enquirystate',lb:'State',nm:'esi',nx:'esx',vf:'rid',vx:'rix',df:'nam',rf:'esn'},
  //frequency:{sv:'frequency',lb:'Frequency',nm:'fri',nx:'frx',vf:'rid',vx:'rix',df:'nam',rf:'frn'},
  gender:{sv:'gender',lb:'Gender',nm:'gdi',nx:'gdx',vf:'rid',vx:'rix',df:'nam',rf:'gdn'},
  idtype:{sv:'idtype',lb:'ID Type',nm:'iti',nx:'itx',vf:'rid',vx:'rix',df:'nam',rf:'itn'},
  //limit:{sv:'limit',lb:'Limit',nm:'lmi',nx:'lmx',vf:'rid',vx:'rix',df:'nam',rf:'lmn'},
  linker:{sv:'contact',lb:'Linker',nm:'rci',nx:'rcx',vf:'rid',vx:'rix',df:'nam',rf:'rcn'},
  linked:{sv:'contact',lb:'Linked',nm:'dci',nx:'dcx',vf:'rid',vx:'rix',df:'nam',rf:'dcn'},
  linktype:{sv:'linktype',lb:'Type',nm:'lti',nx:'ltx',vf:'rid',vx:'rix',df:'nam',rf:'ltc'},
  location:{sv:'location',lb:'Location',nm:'lci',nx:'lcx',vf:'rid',vx:'rix',df:'nam',rf:'lcn'},
  locationtype:{sv:'locationtype',lb:'Location Type',nm:'lti',nx:'ltn',vf:'rid',vx:'rix',df:'nam',rf:'ltn'},
  messagetype:{sv:'messagetype',lb:'Type',nm:'mti',nx:'mtx',vf:'rid',vx:'rix',df:'nam',rf:'mtn'},
  messagemode:{sv:'messagemode',lb:'Mode',nm:'mmi',nx:'mmx',vf:'rid',vx:'rix',df:'nam',rf:'mmn'},
  messagechannel:{sv:'messagechannel',lb:'Channel',nm:'mci',nx:'mcx',vf:'rid',vx:'rix',df:'nam',rf:'mcn'},
  messagestate:{sv:'messagestate',lb:'State',nm:'msi',nx:'msx',vf:'rid',vx:'rix',df:'nam',rf:'msn'},
  region:{sv:'region',lb:'Region',nm:'rgi',nx:'rgx',vf:'rid',vx:'rix',df:'nam',rf:'rgn'},
  report:{sv:'report',lb:'Report',nm:'rpi',nx:'rpx',vf:'rid',vx:'rix',df:'nam',rf:'rpn'},

  // core main
  connection:{sv:'connection',lb:'connection',nm:'cni',nx:'cnx',vf:'rid',vx:'rix',df:'nam',rf:'cnn'},
  contact:{sv:'contact',lb:'contact',nm:'cti',nx:'ctx',vf:'rid',vx:'rix',df:'nam',rf:'ctn'},
  contactlink:{sv:'contactlink',lb:'contactlink',nm:'cli',nx:'clx',vf:'rid',vx:'rix',df:'nam',rf:'cln'},
  dashtab:{sv:'dashtab',lb:'dashtab',nm:'dti',nx:'dtx',vf:'rid',vx:'rix',df:'nam',rf:'dtn'},
  device:{sv:'device',lb:'device',nm:'dvi',nx:'dvx',vf:'rid',vx:'rix',df:'nam',rf:'dvn'},
  enquiry:{sv:'enquiry',lb:'enquiry',nm:'eqi',nx:'eqx',vf:'rid',vx:'rix',df:'nam',rf:'eqn'},
  entitylocation:{sv:'entitylocation',lb:'entitylocation',nm:'eli',nx:'elx',vf:'rid',vx:'rix',df:'nam',rf:'eln'},
  linkstate:{sv:'linkstate',lb:'linkstate',nm:'lsi',nx:'lsx',vf:'rid',vx:'rix',df:'nam',rf:'lsn'},
  linkstatus:{sv:'linkstatus',lb:'linkstatus',nm:'lsi',nx:'lsx',vf:'rid',vx:'rix',df:'nam',rf:'lsn'},
  message:{sv:'message',lb:'message',nm:'msi',nx:'msx',vf:'rid',vx:'rix',df:'nam',rf:'msn'},
  orgtype:{sv:'orgtype',lb:'orgtype',nm:'oti',nx:'otx',vf:'rid',vx:'rix',df:'nam',rf:'otn'},
  reportheader:{sv:'reportheader',lb:'reportheader',nm:'rhi',nx:'rhx',vf:'rid',vx:'rix',df:'nam',rf:'rhn'},
  reportsettings:{sv:'reportsettings',lb:'reportsettings',nm:'rsi',nx:'rsx',vf:'rid',vx:'rix',df:'nam',rf:'rsn'},
  reportsummary:{sv:'reportsummary',lb:'reportsummary',nm:'rsi',nx:'rsx',vf:'rid',vx:'rix',df:'nam',rf:'rsn'},
  
  // main basics
  productcategory:{sv:'productcategory',lb:'productcategory',nm:'pci',nx:'pcx',vf:'rid',vx:'rix',df:'nam',rf:'pcn'},
  stafflevel:{sv:'stafflevel',lb:'stafflevel',nm:'sli',nx:'slx',vf:'rid',vx:'rix',df:'nam',rf:'sln'},
  staffplanstate:{sv:'staffplanstate',lb:'staffplanstate',nm:'psi',nx:'psx',vf:'rid',vx:'rix',df:'nam',rf:'psn'},
  staffrole:{sv:'staffrole',lb:'staffrole',nm:'sri',nx:'srx',vf:'rid',vx:'rix',df:'nam',rf:'srn'},
  stafftype:{sv:'stafftype',lb:'stafftype',nm:'sti',nx:'stx',vf:'rid',vx:'rix',df:'nam',rf:'stn'},
  staffuserstate:{sv:'staffuserstate',lb:'staffuserstate',nm:'ssi',nx:'ssx',vf:'rid',vx:'rix',df:'nam',rf:'ssn'},
  staffusertype:{sv:'staffusertype',lb:'staffusertype',nm:'sti',nx:'stx',vf:'rid',vx:'rix',df:'nam',rf:'stn'},
  unitcat:{sv:'unitcat',lb:'unitcat',nm:'uci',nx:'ucx',vf:'rid',vx:'rix',df:'nam',rf:'ucn'},
  unitclass:{sv:'unitclass',lb:'unitclass',nm:'oci',nx:'ocx',vf:'rid',vx:'rix',df:'nam',rf:'ocn'},
  unitgroup:{sv:'unitgroup',lb:'unitgroup',nm:'ugi',nx:'ugx',vf:'rid',vx:'rix',df:'nam',rf:'ugn'}, 
  unittype:{sv:'unittype',lb:'unittype',nm:'uti',nx:'utx',vf:'rid',vx:'rix',df:'nam',rf:'utn'},

  // main main
  orgunit:{sv:'orgunit',lb:'orgunit',nm:'unn',nx:'oux',vf:'rid',vx:'rix',df:'nam',rf:'unn'},
  product:{sv:'product',lb:'product',nm:'pdi',nx:'pdx',vf:'rid',vx:'rix',df:'nam',rf:'pdn'},
  staff:{sv:'staff',lb:'staff',nm:'sfi',nx:'sfx',vf:'rid',vx:'rix',df:'nam',rf:'sfn'},
  staffplan:{sv:'staffplan',lb:'staffplan',nm:'spi',nx:'spx',vf:'rid',vx:'rix',df:'nam',rf:'spn'},
  staffuser:{sv:'staffuser',lb:'staffuser',nm:'sui',nx:'sux',vf:'rid',vx:'rix',df:'nam',rf:'sun'},

  // finance basics
  accountcat:{sv:'accountcat',lb:'accountcat',nm:'aci',nx:'acx',vf:'rid',vx:'rix',df:'nam',rf:'acn'},
  accounttype:{sv:'accounttype',lb:'accounttype',nm:'ati',nx:'atx',vf:'rid',vx:'rix',df:'nam',rf:'atn'},
  accountbudget:{sv:'accountbudget',lb:'accountbudget',nm:'abi',nx:'abn',vf:'rid',vx:'rix',df:'nam',rf:'abn'},
  accountbudgetclass:{sv:'accountbudgetclass',lb:'accountbudgetclass',nm:'abi',nx:'abn',vf:'rid',vx:'rix',df:'nam',rf:'abn'},
  accountfunction:{sv:'accountfunction',lb:'accountfunction',nm:'afi',nx:'afn',vf:'rid',vx:'rix',df:'nam',rf:'afn'},
  accountnature:{sv:'accountnature',lb:'accountnature',nm:'ani',nx:'ann',vf:'rid',vx:'rix',df:'nam',rf:'ann'},
  accountcashflow:{sv:'accountcashflow',lb:'accountcashflow',nm:'cfi',nx:'cfn',vf:'rid',vx:'rix',df:'nam',rf:'cfn'},

  // finance main
  costcenter:{sv:'costcenter',lb:'costcenter',nm:'cci',nx:'ccx',vf:'rid',vx:'rix',df:'nam',rf:'ccn'},
  chartofaccounts:{sv:'chartofaccounts',lb:'chartofaccounts',nm:'cai',nx:'cax',vf:'rid',vx:'rix',df:'nam',rf:'can'},

  // budget basics
  budgetcycle:{sv:'budgetcycle',lb:'budgetcycle',nm:'bci',nx:'bcx',vf:'rid',vx:'rix',df:'nam',rf:'bcn'},
  budgetexecutionstate:{sv:'budgetexecutionstate',lb:'budgetexecutionstate',nm:'xsi',nx:'xsx',vf:'rid',vx:'rix',df:'nam',rf:'xsn'},
  budgetexecutiontype:{sv:'budgetexecutiontype',lb:'budgetexecutiontype',nm:'xti',nx:'xtx',vf:'rid',vx:'rix',df:'nam',rf:'xtn'},
  budgetscenario:{sv:'budgetscenario',lb:'budgetscenario',nm:'sci',nx:'scx',vf:'rid',vx:'rix',df:'nam',rf:'scn'},
  budgetstate:{sv:'budgetstate',lb:'budgetstate',nm:'bsi',nx:'bsx',vf:'rid',vx:'rix',df:'nam',rf:'bsn'},
  budgettype:{sv:'budgettype',lb:'budgettype',nm:'bti',nx:'btx',vf:'rid',vx:'rix',df:'nam',rf:'btn'},
  executionnature:{sv:'executionnature',lb:'executionnature',nm:'eni',nx:'xnx',vf:'rid',vx:'rix',df:'nam',rf:'enn'},
  executionsource:{sv:'executionsource',lb:'executionsource',nm:'esi',nx:'xox',vf:'rid',vx:'rix',df:'nam',rf:'esn'},
  executionstate:{sv:'executionstate',lb:'executionstate',nm:'xsi',nx:'xsx',vf:'rid',vx:'rix',df:'nam',rf:'xsn'},
  executiontype:{sv:'executiontype',lb:'executiontype',nm:'xti',nx:'xtx',vf:'rid',vx:'rix',df:'nam',rf:'xtn'},
  investmentstate:{sv:'investmentstate',lb:'investmentstate',nm:'isi',nx:'isx',vf:'rid',vx:'rix',df:'nam',rf:'isn'},
  investmenttype:{sv:'investmenttype',lb:'investmenttype',nm:'iti',nx:'itx',vf:'rid',vx:'rix',df:'nam',rf:'itn'},
  lineitemstate:{sv:'lineitemstate',lb:'lineitemstate',nm:'lsi',nx:'lsx',vf:'rid',vx:'rix',df:'nam',rf:'lsn'},
  lineitemtype:{sv:'lineitemtype',lb:'lineitemtype',nm:'iti',nx:'ltx',vf:'rid',vx:'rix',df:'nam',rf:'itn'},
  transactionstate:{sv:'transactionstate',lb:'transactionstate',nm:'tsi',nx:'tsx',vf:'rid',vx:'rix',df:'nam',rf:'tsn'},
  transactiontype:{sv:'transactiontype',lb:'Transaction Type',nm:'tti',nx:'ttx',vf:'rid',vx:'rix',df:'nam',rf:'xtn'},
  
  // budget main
  budgetperiod:{sv:'budgetperiod',lb:'budgetperiod',nm:'bpi',nx:'bpx',vf:'rid',vx:'rix',df:'nam',rf:'bpn'},
  budgetplan:{sv:'budgetplan',lb:'budgetplan',nm:'pni',nx:'pnx',vf:'rid',vx:'rix',df:'nam',rf:'pnn'},
  investmentproject:{sv:'investmentproject',lb:'investmentproject',nm:'pri',nx:'prx',vf:'rid',vx:'rix',df:'nam',rf:'prn'},
  lineitem:{sv:'lineitem',lb:'lineitem',nm:'lii',nx:'lix',vf:'rid',vx:'rix',df:'nam',rf:'lin'},
  revision:{sv:'revision',lb:'revision',nm:'rvi',nx:'rvx',vf:'rid',vx:'rix',df:'nam',rf:'rvn'},
  itemreview:{sv:'itemreview',lb:'itemreview',nm:'rvi',nx:'rvx',vf:'rid',vx:'rix',df:'nam',rf:'rvn'},

  // forms requisition basics
  itemreviewstate:{sv:'itemreviewstate',lb:'itemreviewstate',nm:'rsi',nx:'rsx',vf:'rid',vx:'rix',df:'nam',rf:'rsn'},
  reviewstate:{sv:'itemreviewstate',lb:'itemreviewstate',nm:'rsi',nx:'rsx',vf:'rid',vx:'rix',df:'nam',rf:'rsn'},
  priority:{sv:'priority',lb:'priority',nm:'pri',nx:'prx',vf:'rid',vx:'rix',df:'nam',rf:'prn'},
  requisitionitemstate:{sv:'requisitionitemstate',lb:'requisitionitemstate',nm:'isi',nx:'isx',vf:'rid',vx:'rix',df:'nam',rf:'isn'},
  requisitionitemtype:{sv:'requisitionitemtype',lb:'requisitionitemtype',nm:'iti',nx:'itx',vf:'rid',vx:'rix',df:'nam',rf:'itn'},
  requisitionstate:{sv:'requisitionstate',lb:'requisitionstate',nm:'rsi',nx:'rsx',vf:'rid',vx:'rix',df:'nam',rf:'rsn'},
  requisitiontype:{sv:'requisitiontype',lb:'requisitiontype',nm:'rti',nx:'rtx',vf:'rid',vx:'rix',df:'nam',rf:'rtn'},
  resourcetype:{sv:'resourcetype',lb:'resourcetype',nm:'rci',nx:'rcx',vf:'rid',vx:'rix',df:'nam',rf:'rcn'},
  uom:{sv:'uom',lb:'uom',nm:'umi',nx:'umx',vf:'rid',vx:'rix',df:'nam',rf:'umn'},

  // forms requisition main
  requisition:{sv:'requisition',lb:'requisition',nm:'rqi',nx:'rqx',vf:'rid',vx:'rix',df:'nam',rf:'rqn'},
  requisitionitem:{sv:'requisitionitem',lb:'requisitionitem',nm:'qii',nx:'qix',vf:'rid',vx:'rix',df:'nam',rf:'qin'},

  // activity basics
  activityoutputstate:{sv:'activityoutputstate',lb:'activityoutputstate',nm:'osi',nx:'osx',vf:'rid',vx:'rix',df:'nam',rf:'osn'},
  activityperfstate:{sv:'activityperfstate',lb:'activityperfstate',nm:'psi',nx:'psx',vf:'rid',vx:'rix',df:'nam',rf:'psn'},
  activityplanstate:{sv:'activityplanstate',lb:'activityplanstate',nm:'psi',nx:'psx',vf:'rid',vx:'rix',df:'nam',rf:'psn'},
  activitystate:{sv:'activitystate',lb:'Activity State',nm:'asi',nx:'asx',vf:'rid',vx:'rix',df:'nam',rf:'asn'},
  activitytype:{sv:'activitytype',lb:'Activity Type',nm:'ati',nx:'atx',vf:'rid',vx:'rix',df:'nam',rf:'atn'},
  
  // activity main
  activity:{sv:'activity',lb:'Activity',nm:'aci',nx:'acx',vf:'rid',vx:'rix',df:'nam',rf:'acn'},
  activityclass:{sv:'activityclass',lb:'Activity Class',nm:'aci',nx:'acx',vf:'rid',vx:'rix',df:'nam',rf:'acn'},
  activityoutput:{sv:'activityoutput',lb:'activityoutput',nm:'aoi',nx:'aox',vf:'rid',vx:'rix',df:'nam',rf:'aon'},
  activityplan:{sv:'activityplan',lb:'activityplan',nm:'api',nx:'apx',vf:'rid',vx:'rix',df:'nam',rf:'apn'},
  driver:{sv:'driver',lb:'driver',nm:'dri',nx:'drx',vf:'rid',vx:'rix',df:'nam',rf:'drn'},

  // bie basics
  biedrivertype:{sv:'biedrivertype',lb:'Driver Type',nm:'tyi',nx:'tyx',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},
  bierelationshiptype:{sv:'bierelationshiptype',lb:'Relationship Type',nm:'tyi',nx:'tyx',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},
  bieunit:{sv:'bieunit',lb:'BIE Unit',nm:'uni',nx:'unx',vf:'rid',vx:'rix',df:'nam',rf:'unn'},
  bieentitytype:{sv:'bieentitytype',lb:'BIE Entity Type',nm:'tyi',nx:'tyx',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},
  bieflowtype:{sv:'bieflowtype',lb:'BIE Flow Type',nm:'tyi',nx:'tyx',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},
  biegroup:{sv:'biegroup',lb:'Group',nm:'gpi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  biescenariotype:{sv:'biescenariotype',lb:'Scenario Type',nm:'tyi',nx:'tix',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},


  //bieentitytype:{sv:'bieentitytype',lb:'BIE Entity Type',nm:'gpi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  bieentrytype:{sv:'bieentrytype',lb:'BIE Entry Type',nm:'eni',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'etn'},
  //bieflowtype:{sv:'bieflowtype',lb:'BIE Flow Type',nm:'gpi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'}, 
  bieformulascope:{sv:'bieformulascope',lb:'BIE Formula Scope',nm:'fsi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'}, 
  bieimportsource:{sv:'bieimportsource',lb:'BIE Import Source',nm:'isi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'}, 
  bielocationtype:{sv:'bielocationtype',lb:'BIE Location Type',nm:'lci',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'}, 
  bieobjectivetype:{sv:'bieobjectivetype',lb:'BIE Objective Type',nm:'oti',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  bieperiodtype:{sv:'bieperiodtype',lb:'BIE Period Type',nm:'pti',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  //bierelationshiptype:{sv:'bierelationshiptype',lb:'BIE Relationship Type',nm:'gpi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  bieresulttype:{sv:'bieresulttype',lb:'BIE Result Type',nm:'rti',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  //biescenariotype:{sv:'biescenariotype',lb:'BIE Scenario Type',nm:'sti',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  biestate:{sv:'biestate',lb:'BIE State',nm:'ssi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  //bieunit:{sv:'bieunit',lb:'BIE Unit',nm:'gpi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  bievaluesource:{sv:'bievaluesource',lb:'BIE Value Source',nm:'vsi',nx:'rix',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},
  //biescenariotype:{sv:'biescenariotype',lb:'BIE Scenario Type',nm:'tyi',nx:'tix',vf:'rid',vx:'rix',df:'nam',rf:'tyn'},

  // bie main
  biescenario:{sv:'biescenario',lb:'BIE Scenario',nm:'sci',nx:'scx',vf:'rid',vx:'rix',df:'nam',rf:'scn'},
  bieflow:{sv:'bieflow',lb:'BIE Flow',nm:'fli',nx:'flx',vf:'rid',vx:'rix',df:'nam',rf:'fln'},
  biedriver:{sv:'biedriver',lb:'BIE Driver',nm:'dri',nx:'drx',vf:'rid',vx:'rix',df:'nam',rf:'drn'},
  bieparentdriver:{sv:'biedriver',lb:'BIE Parent Driver',nm:'pdi',nx:'pdx',vf:'rid',vx:'rix',df:'nam',rf:'pdn'},
  biechilddriver:{sv:'biedriver',lb:'BIE Child Driver',nm:'cdi',nx:'cdx',vf:'rid',vx:'rix',df:'nam',rf:'cdn'},
  bielocation:{sv:'bielocation',lb:'BIE Location',nm:'lci',nx:'lcx',vf:'rid',vx:'rix',df:'nam',rf:'lcn'},
  bieperiod:{sv:'bieperiod',lb:'BIE Period',nm:'pdi',nx:'pdx',vf:'rid',vx:'rix',df:'nam',rf:'pdn'},
  bieentity:{sv:'bieentity',lb:'BIE Entity',nm:'eni',nx:'enx',vf:'rid',vx:'rix',df:'nam',rf:'enn'},
  biecapacitypolicy:{sv:'biecapacitypolicy',lb:'BIE Capacity Policy',nm:'cpi',nx:'cpx',vf:'rid',vx:'rix',df:'nam',rf:'cpn'},

  // kpis basics
  axis:{sv:'axis',lb:'axis',nm:'axi',nx:'axx',vf:'rid',vx:'rix',df:'nam',rf:'axn'},
  kpifrequency:{sv:'kpifrequency',lb:'kpifrequency',nm:'kfi',nx:'kfx',vf:'rid',vx:'rix',df:'nam',rf:'kfn'},
  kpiperfstate:{sv:'kpiperfstate',lb:'kpiperfstate',nm:'psi',nx:'psx',vf:'rid',vx:'rix',df:'nam',rf:'psn'},
  kpiplanstate:{sv:'kpiplanstate',lb:'kpiplanstate',nm:'psi',nx:'psx',vf:'rid',vx:'rix',df:'nam',rf:'psn'},
  kpiplantype:{sv:'kpiplantype',lb:'kpiplantype',nm:'pti',nx:'ptx',vf:'rid',vx:'rix',df:'nam',rf:'ptn'},
  kpistate:{sv:'kpistate',lb:'kpistate',nm:'ksi',nx:'ksx',vf:'rid',vx:'rix',df:'nam',rf:'ksn'},
  kpitype:{sv:'kpitype',lb:'kpitype',nm:'kti',nx:'ktx',vf:'rid',vx:'rix',df:'nam',rf:'ktn'},
  objectivestate:{sv:'objectivestate',lb:'objectivestate',nm:'osi',nx:'osx',vf:'rid',vx:'rix',df:'nam',rf:'osn'},
  objectivetype:{sv:'objectivetype',lb:'objectivetype',nm:'oti',nx:'otx',vf:'rid',vx:'rix',df:'nam',rf:'otn'},

  // kpis main
  kpimaster:{sv:'kpimaster',lb:'kpimaster',nm:'kmi',nx:'kmx',vf:'rid',vx:'rix',df:'nam',rf:'kmn'},
  kpiplan:{sv:'kpiplan',lb:'kpiplan',nm:'kpi',nx:'kpx',vf:'rid',vx:'rix',df:'nam',rf:'kpn'},
  objective:{sv:'objective',lb:'objective',nm:'obi',nx:'obx',vf:'rid',vx:'rix',df:'nam',rf:'obn'},
  globalobjective:{sv:'globalobjective',lb:'Global Objective',nm:'obi',nx:'obx',vf:'rid',vx:'rix',df:'nam',rf:'gon'},
  specificobjective:{sv:'specificobjective',lb:'Specific Objective',nm:'obi',nx:'obx',vf:'rid',vx:'rix',df:'nam',rf:'son'},

  // files
  filegroup:{sv:'filegroup',lb:'Group',nm:'gpi',nx:'gpx',vf:'rid',vx:'rix',df:'nam',rf:'gpn'},

  // files main
  file:{sv:'file',lb:'file',nm:'fli',nx:'flx',vf:'rid',vx:'rix',df:'nam',rf:'fln'},
  form:{sv:'form',lb:'form',nm:'fmi',nx:'fmx',vf:'rid',vx:'rix',df:'nam',rf:'fmn'},

  // apis basics
  apiaccounttype:{sv:'apiaccounttype',lb:'apiaccounttype',nm:'ati',nx:'atx',vf:'rid',vx:'rix',df:'nam',rf:'atn'},
  apitype:{sv:'apitype',lb:'apitype',nm:'ati',nx:'atx',vf:'rid',vx:'rix',df:'nam',rf:'atn'},
  apichannel:{sv:'apichannel',lb:'apichannel',nm:'chi',nx:'chx',vf:'rid',vx:'rix',df:'nam',rf:'chn'},
  apiprovidertype:{sv:'apiprovidertype',lb:'apiprovidertype',nm:'pti',nx:'ptx',vf:'rid',vx:'rix',df:'nam',rf:'ptn'},

  // apis main
  apiaccount:{sv:'apiaccount',lb:'apiaccount',nm:'aci',nx:'acx',vf:'rid',vx:'rix',df:'nam',rf:'acn'},
  apimaster:{sv:'apimaster',lb:'apimaster',nm:'api',nx:'apx',vf:'rid',vx:'rix',df:'nam',rf:'apn'},
  apiprovider:{sv:'apiprovider',lb:'apiprovider',nm:'pvi',nx:'pvx',vf:'rid',vx:'rix',df:'nam',rf:'pvn'},

  // uiux basics
  uidoc:{sv:'uidoc',lb:'UI Document',nm:'dci',nx:'dcx',vf:'rid',vx:'rix',df:'nam',rf:'dcn'},
  uipage:{sv:'uipage',lb:'UI Page',nm:'pgi',nx:'pgx',vf:'rid',vx:'rix',df:'nam',rf:'pgn'},
  uisection:{sv:'uisection',lb:'UI Section',nm:'sci',nx:'scx',vf:'rid',vx:'rix',df:'nam',rf:'scn'},
  uidevice:{sv:'uidevice',lb:'UI Device',nm:'dvi',nx:'dvx',vf:'rid',vx:'rix',df:'nam',rf:'dvn'},
  uilang:{sv:'uilang',lb:'UI Language',nm:'lgi',nx:'lgx',vf:'rid',vx:'rix',df:'nam',rf:'lgn'},

  // events basics
  alertseverity:{sv:'alertseverity',lb:'alertseverity',nm:'svi',nx:'svx',vf:'rid',vx:'rix',df:'nam',rf:'svn'},
  alertstate:{sv:'alertstate',lb:'alertstate',nm:'asi',nx:'asx',vf:'rid',vx:'rix',df:'nam',rf:'asn'},
  announcestate:{sv:'announcestate',lb:'announcestate',nm:'asi',nx:'asx',vf:'rid',vx:'rix',df:'nam',rf:'asn'},
  appservice:{sv:'appservice',lb:'appservice',nm:'svi',nx:'svx',vf:'rid',vx:'rix',df:'nam',rf:'svn'},
  audience:{sv:'audience',lb:'audience',nm:'aui',nx:'aux',vf:'rid',vx:'rix',df:'nam',rf:'aun'},
  eventstate:{sv:'eventstate',lb:'eventstate',nm:'vsi',nx:'vsx',vf:'rid',vx:'rix',df:'nam',rf:'vsn'},
  
  eventtype:{sv:'eventtype',lb:'eventtype',nm:'vti',nx:'vtx',vf:'rid',vx:'rix',df:'nam',rf:'vtn'},
  serviceaction:{sv:'serviceaction',lb:'serviceaction',nm:'sai',nx:'sax',vf:'rid',vx:'rix',df:'nam',rf:'san'},
  supportpriority:{sv:'supportpriority',lb:'supportpriority',nm:'spi',nx:'spx',vf:'rid',vx:'rix',df:'nam',rf:'spn'},
  supportstate:{sv:'supportstate',lb:'supportstate',nm:'ssi',nx:'ssx',vf:'rid',vx:'rix',df:'nam',rf:'ssn'},
  topicchannel:{sv:'topicchannel',lb:'topicchannel',nm:'tci',nx:'tcx',vf:'rid',vx:'rix',df:'nam',rf:'tcn'},
  topicscope:{sv:'topicscope',lb:'topicscope',nm:'tsi',nx:'tsx',vf:'rid',vx:'rix',df:'nam',rf:'tsn'},

  // events main
  alert:{sv:'alert',lb:'alert',nm:'ali',nx:'alx',vf:'rid',vx:'rix',df:'nam',rf:'aln'},
  announce:{sv:'announce',lb:'announce',nm:'ani',nx:'anx',vf:'rid',vx:'rix',df:'nam',rf:'ann'},
  event:{sv:'event',lb:'event',nm:'evi',nx:'evx',vf:'rid',vx:'rix',df:'nam',rf:'evn'},
  socketmap:{sv:'socketmap',lb:'socketmap',nm:'smi',nx:'smx',vf:'rid',vx:'rix',df:'nam',rf:'smn'},
  supportcomment:{sv:'supportcomment',lb:'supportcomment',nm:'sci',nx:'scx',vf:'rid',vx:'rix',df:'nam',rf:'scn'},
  supportticket:{sv:'supportticket',lb:'supportticket',nm:'sti',nx:'stx',vf:'rid',vx:'rix',df:'nam',rf:'stn'},
  topic:{sv:'topic',lb:'topic',nm:'tpi',nx:'tpx',vf:'rid',vx:'rix',df:'nam',rf:'tpn'},
  
  // workflow basics
  workflowaction:{sv:'workflowaction',lb:'workflowaction',nm:'wai',nx:'wax',vf:'rid',vx:'rix',df:'nam',rf:'wan'},
  workflowpriority:{sv:'workflowpriority',lb:'workflowpriority',nm:'wpi',nx:'wpx',vf:'rid',vx:'rix',df:'nam',rf:'wpn'},
  
  // workflow main
  workflow:{sv:'workflow',lb:'workflow',nm:'wfi',nx:'wfx',vf:'rid',vx:'rix',df:'nam',rf:'wfn'},
  workflowhistory:{sv:'workflowhistory',lb:'workflowhistory',nm:'whi',nx:'whx',vf:'rid',vx:'rix',df:'nam',rf:'whn'},
  workflowruntime:{sv:'workflowruntime',lb:'workflowruntime',nm:'wri',nx:'wrx',vf:'rid',vx:'rix',df:'nam',rf:'wrn'},
  workflowstate:{sv:'workflowstate',lb:'workflowstate',nm:'wsi',nx:'wsx',vf:'rid',vx:'rix',df:'nam',rf:'wsn'},
  workflowtask:{sv:'workflowtask',lb:'workflowtask',nm:'wki',nx:'wkx',vf:'rid',vx:'rix',df:'nam',rf:'wkn'},
  workflowtransition:{sv:'workflowtransition',lb:'workflowtransition',nm:'wti',nx:'wtx',vf:'rid',vx:'rix',df:'nam',rf:'wtn'},
  
};

const lcs:any = {
  branch: { lb: 'Branch', nm: 'bri', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
  context: { lb: 'Context', nm: 'ctx', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Default'], [2, 'Ordering'], [4, 'Production'], [8, 'Distribution'], [16, 'Installation'], [32, 'Maintenance']] },
  credit: { lb: 'Credit', nm: 'cre', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, '1 HR'], [2, '2 HRS'], [3, '3 HRS'], [4, '4 HRS'], [5, '5 HR'], [6, '6 HRS'], [7, '7 HRS'], [8, '8 HRS']] },
  country: { lb: 'Country', nm: 'coi', vf: 'rid', df: 'nam', et: 'Select', sd: [['1', 'Ghana'], ['2', 'Nigeria'], ['3', "Cote D'Ivoire"]] },
  format: { lb: 'Format', nm: 'fmt', vf: 'rid', df: 'nam', et: 'Select', sd: [['pdf', 'Portable Document(PDF)'], ['csv', 'Comma Separated(CSV)']] },
  gender: { lb: 'Gender', nm: 'gdi', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Male'], [0, 'Female']] },
  regstatus: { lb: 'Registration', nm: 'rst', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Registered'], [0, 'Unregistered']] },
  reporttype: { lb: 'Report Type', nm: 'rpt', vf: 'rid', df: 'nam', et: 'Select', sd: [['sum', 'Summary'], ['det', 'Detail']] },
  //service: { lb: 'Service', nm: 'svc', vf: 'rid', df: 'nam', et: 'Select', sd: servicelist },
  status: { lb: 'Status', nm: 'sts', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Enabled'], [0, 'Disabled'], [2, 'Locked']] },
  title: { lb: 'Title', nm: 'tti', vf: 'rid', df: 'nam', et: 'Select', sd: [[3, 'Dr.'], [2, 'Mrs.'], [1, 'Mr.'], [0, 'Miss']] },
  truthy: { lb: 'Yes/No', nm: 'yn', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Yes'], [0, 'No']] },
  sector: { lb: 'Sector', nm: 'sci', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
  investmenttype: { lb: 'Type', nm: 'itc', vf: 'rid', df: 'nam', et: 'Select', sd: [['CAPEX','CAPEX'],
    ['EQUIPMENT','Equipment'],
    ['INFRASTRUCTURE','Infrastructure'],
    ['IT','IT'],
    ['VEHICLE','Vehicle']] },
  investmentpriority: { lb: 'Sector', nm: 'sci', vf: 'rid', df: 'nam', et: 'Select', sd: [['HIGH','High'],
    ['MEDIUM','Medium'],
    ['LOW','Low']] },
  

};

function basic(service:string){
  return bcs[service];
}

function local(service:string){
  return lcs[service];
}

function combo(service:string){
  return bcs[service] || lcs[service];
}

function combox(type:string,service:string){
  return ({bcs,lcs} as any)[type]?.[service];
}

export {bcs, lcs, basic, local, combo};
export default combox;
